/* eslint-disable */
import SceneBase from "./common/SceneBase";
import Star from "./scene_opening/Star";
import CharaHuman from "./scene_opening/chara/CharaHuman";
import CharaEarth from "./scene_opening/chara/CharaEarth";

class SceneOpening extends SceneBase {
  constructor(engine) {
    super(engine);
    this.step = 0;
  }

  //------------------------------------
  // setup
  //------------------------------------
  setup() {
    super.setup();

    //charactor
    this.charaHuman = new CharaHuman(this.scene);
    this.charaEarth = new CharaEarth(this.scene);

    this.ringStar01_root = this.scene.getNodeByID("RingStar01_root");
    this.ringStar02_root = this.scene.getNodeByID("RingStar02_root");
    this.ringStar03_root = this.scene.getNodeByID("RingStar03_root");
    this.ringStar01_root.rotation.z = (Math.random() * 360 * Math.PI) / 180;
    this.ringStar02_root.rotation.z = (Math.random() * 360 * Math.PI) / 180;
    this.ringStar03_root.rotation.z = (Math.random() * 360 * Math.PI) / 180;

    //star
    this.star = new Star(this.scene);
    this.star.getRoot().parent = this.getRoot();
  }

  //------------------------------------
  // Camera
  //------------------------------------
  initCamera() {
    super.initCamera();
    this.camera.setPosition(new BABYLON.Vector3(0, 0, 75));
    this.camera.setTarget(new BABYLON.Vector3(0, 50, 0));
    this.scene.activeCamera = this.camera;
  }

  //------------------------------------
  // changeStatus
  //------------------------------------
  changeStatus(bool) {
    if (this.status !== bool) {
      if (bool) {
        this.star.create();
      } else {
        this.star.reset();
      }
    }

    super.changeStatus(bool);
  }

  //------------------------------------
  // Step Control
  //------------------------------------
  changeStep(step) {
    this.step = step;

    switch (this.step) {
      case 1:
        //camera
        this.cameraPosition = new BABYLON.Vector3(0, 0, 75);
        this.cameraTarget = new BABYLON.Vector3(0, 0, 0);
        this.cameraSpeed = 125;

        //charactor
        this.charaHuman.changePosition(new BABYLON.Vector3(0, 0, 50), 150);
        this.charaHuman.startAnimation("Waiting", true);

        this.wipeOpen();
        break;
      case 2:
        //camera
        this.cameraPosition = new BABYLON.Vector3(0, 0, 200);
        this.cameraSpeed = 100;

        //charactor
        this.charaHuman.startAnimation("Wave", true);
        this.charaHuman.changePosition(new BABYLON.Vector3(0, 0, 175), 100);
        break;

      case 3:
        //camera
        this.cameraPosition = new BABYLON.Vector3(0, 0, 50);
        this.cameraSpeed = 50;

        //charactor
        this.charaHuman.changePosition(new BABYLON.Vector3(0, 0, 25), 50);
        this.charaHuman.startAnimation("Waiting", true);

        setTimeout(() => {
          this.wipeClose();
        }, 500);
        break;
    }
  }

  //------------------------------------
  // Update
  //------------------------------------
  update() {
    if (this.status) {
      super.update();

      this.updateCamera(
        this.cameraPosition,
        this.cameraTarget,
        this.cameraSpeed
      );

      //charactor
      this.charaHuman.update();
      this.charaEarth.update();

      //ring
      this.scene.getMeshByID("Ring01").rotation.y += 0.001;
      this.scene.getMeshByID("Ring02").rotation.y += 0.002;
      this.scene.getMeshByID("Ring03").rotation.y += 0.003;

      this.scene.getNodeByID("RingStar01_root").rotation.z += 0.01;
      this.scene.getNodeByID("RingStar02_root").rotation.z += 0.01;
      this.scene.getNodeByID("RingStar03_root").rotation.z += 0.01;
    }
  }
}
export default SceneOpening;
